import { createSelector } from "reselect";

export const draftsStateSelector = state => state.stickers.drafts;

export const draftContinueModalVisibilitySelector = createSelector(
  draftsStateSelector,
  (layoutState) => layoutState.showDraftContinueModal
);

export const draftStickerSelector = createSelector(
  draftsStateSelector,
  (layoutState) => layoutState.draftSticker
);